import axios from 'axios'
import {Message} from 'element-ui'
import {removeToken} from '@/utils/auth'
import router from '@/router'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_URL, // api的base_url
  timeout: 180000, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  let token = localStorage.getItem('tokenVue') || '';
  config.headers.Token = token;
  config.headers.Authorization = token;
  config.headers['x-preference'] = sessionStorage.getItem("x-preference");
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status === 1 && res.message === 'token 异常') {
      Message({
        message: res.message,
        type: 'error',
        duration: 2000,
      });
      removeToken();
      setTimeout(function () {
        router.push({path: '/login', query: {}})
        location.reload()
      }, 2000);
      return Promise.reject("未登录");
    }
    return res;
  },
  error => {
    console.error('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/api.js